<script lang="ts" setup>
  import type { PlayerChoosingView } from '../../../../shared/api/round.ts';
  import { Logo } from '../../../../shared/ui/logo';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import RoundHeader from './RoundHeader.vue';
  import RoundsUntilIChoose from './RoundsUntilIChoose.vue';

  defineProps<{ data: PlayerChoosingView; secondsLeft: string; isHost: boolean }>();
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <RoundHeader :is-host="isHost" :seconds-left="secondsLeft" :view="data" />
    </template>

    <RoundsUntilIChoose :rounds-until-i-choose="data.roundsUntilIChoose" />
    <Logo class="waiting-logo" />
    <div v-if="data.round.chooser" class="waiting-content">
      <p class="waiting-text">
        Waiting for <span class="chooser-name">{{ data.round.chooser.nickname }}</span>
      </p>
      <p class="waiting-subtext">to choose a song...</p>
    </div>
    <div v-else class="waiting-content">
      <p class="waiting-text">Picking a song</p>
      <p class="waiting-subtext">from the playlist...</p>
    </div>
  </MobileViewLayout>
</template>

<style scoped>
  .waiting-logo {
    filter: drop-shadow(0 4px 6px var(--color-shadow));
  }

  .waiting-content {
    text-align: center;
  }

  .waiting-text {
    font-size: var(--font-size-lg);
    line-height: 1.2;
    margin: 0;
  }

  .chooser-name {
    color: var(--color-primary);
    display: block;
    font-family: var(--font-nickname);
    font-size: var(--font-size-xl);
    margin-top: 0.5rem;
    text-transform: uppercase;
  }

  .waiting-subtext {
    color: var(--color-text-muted);
    font-size: var(--font-size-md);
    margin-top: 0.75rem;
  }
</style>
